import { Colors } from '@oy/uicore';
import { Highlight, Text } from '@oy/uidesktop';
import { LogoIcon, ProductFeatureIcon } from '@oy/uiicon';
import classNames from 'classnames';
import { Link } from 'react-router-dom';
import { useTranslate } from 'src/hooks';
import { useSidebarState } from '../Sidebar/hooks';
import styles from './UserMenu.module.css';
import { useUserMenuImpl } from './useUserMenuImpl';

const UserMenu = () => {
  const { getTranslation } = useTranslate();
  const {
    getColor,
    user,
    isProdEnv,
    setIsHover,
    onCloseOnboardUserMenu,
    showOnboardUserMenu,
    onClickUserMenu,
  } = useUserMenuImpl();
  const { isSidebarCollapsed } = useSidebarState();

  return (
    <div className={styles.container}>
      <Highlight
        active={showOnboardUserMenu}
        type="dark"
        position="top"
        target="menuAccount"
        title={getTranslation('settings_onboarding_Titile')}
        desc={getTranslation('settings_onboarding_Description')}
        primaryButton={{
          text: getTranslation('common_understand'),
          action: onCloseOnboardUserMenu,
        }}
      />
      <div
        className={classNames(styles.userMenu, {
          [styles.collapsed]: isSidebarCollapsed,
        })}
      >
        {isSidebarCollapsed ? (
          <ProductFeatureIcon name="settings" color={getColor()} size={24} />
        ) : (
          <>
            <Link
              to="/settings"
              style={{ textDecoration: 'none' }}
              id="menuAccount"
              className={styles.userInfo}
              onClick={onClickUserMenu}
              onMouseEnter={() => setIsHover(true)}
              onMouseLeave={() => setIsHover(false)}
            >
              <div className={styles.bodyText}>
                <Text textStyle={Text.Style.BodySmSemibold} color={getColor()}>
                  {user?.full_name || ''}
                </Text>
                <Text
                  textStyle={Text.Style.BodySmRegular}
                  color={getColor()}
                  className={styles.usernameText}
                >
                  {user?.username || ''}
                </Text>
              </div>
              <ProductFeatureIcon
                name="settings"
                color={getColor()}
                className={styles.icon}
                size={24}
              />
            </Link>
            <div className={styles.footerSection}>
              <Text
                color={isProdEnv ? Colors.WHITE : Colors.BLACK100}
                textStyle={Text.Style.BodyXsRegular}
                className={styles.footerLabel}
              >
                {getTranslation('common_monitoredBy')}
              </Text>
              <LogoIcon
                name={isProdEnv ? 'ojk-white' : 'ojk'}
                width={28}
                height={12}
                alt="OJK"
              />
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default UserMenu;
